document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation for better performance
	document.addEventListener('click', function(e) {
    const clickedElement = e.target.closest('.product__media-item--variant_current .fancybox');
    
    if (clickedElement) {
      e.preventDefault();
      
      // Get only visible media items (current variant)
      const visibleMedia = Array.from(document.querySelectorAll('.product__media-item--variant_current .fancybox'));
      
      // Filter out videos (same as before)
      const imagesOnly = visibleMedia.filter(media => {
        const parent = media.closest('.product__media-item--variant_current');
        return !parent.querySelector('video') && 
               !parent.classList.contains('product__media-video') &&
               !media.src.match(/\.(mp4|webm|ogg|mov)$/i);
      });
      
      // Prepare lightbox items
      const lightboxItems = imagesOnly.map(img => ({
        src: img.src,
        caption: img.getAttribute('data-caption') || ''
      }));
      
      // Find clicked image index
      const clickedIndex = imagesOnly.indexOf(clickedElement);
      
      if (clickedIndex !== -1) {
        Fancybox.show(lightboxItems, {
          Thumbs: false,
          startIndex: clickedIndex
        });
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
      document.querySelectorAll('#or024-test-block, #or029-test-block').forEach(el => el.remove());
  }, 1500);
});
